module.exports = __webpack_public_path__ + "static/media/question.996d7036.png";